interface PlaceholderPageProps {
  title: string;
  icon?: string;
  description?: string;
}

export function PlaceholderPage({
  title,
  icon = "🚧",
  description = "Esta sección estará disponible próximamente.",
}: PlaceholderPageProps) {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center max-w-md">
        <div className="text-6xl mb-4">{icon}</div>
        <h2 className="text-2xl font-bold text-slate-900 mb-2">{title}</h2>
        <p className="text-slate-500">{description}</p>
      </div>
    </div>
  );
}